/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import InquiryToCustomer from "../../../types/Entities/InquiryToCustomer";
import Grid from "@mui/material/Grid";
import DownloadTile from "../../PetitionSummary/Documents/DownloadTile";

type InquiryToCustomerMediaObjectsProps = {
  inquiryToCustomer: InquiryToCustomer;
};

export default function InquiryToCustomerMediaObjects({ inquiryToCustomer }: InquiryToCustomerMediaObjectsProps) {
  return (
    <>
      {inquiryToCustomer.mediaObjects?.length > 0 && (
        <Grid container spacing={1} sx={{
          justifyContent: "flex-start"
        }}>
          {inquiryToCustomer.mediaObjects.map((mediaObject) => (
            <Grid key={mediaObject.id}>
              <DownloadTile mediaObject={mediaObject} size={"minimal"} />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}
